// extracted by mini-css-extract-plugin
export var buttonClean = "ContentTextSection-module--buttonClean--78664";
export var collapseButtonCustom = "ContentTextSection-module--collapseButtonCustom--0ad97";